<template>
	<div class="mt-4">
		<div v-for="document in documents" :key="document.key" class="document-row">
			<div class="flex w-full space-x-4">

				<div class="flex space-x-2 items-start flex-shrink-0">

					<DocumentFileUploader
						v-if="isEditable && document.canUpload"
						:instant-upload="false"
						:accept="document.accept"
						@input="upload(document, $event)"
					>
						<div :title="document.media ? $t('edit_low').toString() : $t('upload').toString()" class="document-action upload-action">
							<font-awesome-icon :icon="['fas', 'upload']" />
						</div>
					</DocumentFileUploader>


					<div v-else class="document-action disabled-action" :title="document.disabledMessage ?? ''">
						<font-awesome-icon :icon="['fas', 'upload']" />
					</div>
				</div>

				<div
					class="font-bold min-w-0"
					:class="{
						'text-gray-500': !document.media,
					}"
				>
					<div class="flex items-center flex-wrap">
						<label
							class="flex-shrink-0 break-words leading-none"
							:class="{
								'cursor-pointer': !!document.media,
							}"
							style="overflow-wrap: anywhere;"
							@click="document.media ? $emit('view', document) : null"
						>
							{{ document.title }}
						</label>

						<label
							v-if="document.media?.created_at"
							:title="document.media.created_at"
							class="text-gray-500 flex-shrink-0 break-words leading-none text-sm ml-1"
						>
							({{ formatDocumentDate(document.media.created_at) }})
						</label>
					</div>
<!--
					<div v-if="document.media" class="text-gray-500 font-normal text-sm mt-1">
						{{ getDocumentName(document) }}
					</div>
-->
					<div v-if="document.disabledMessage" class="text-gray-500 font-normal text-sm mt-1">
						{{ document.disabledMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DocumentFileUploader from '@/components/forms/inputs/DocumentFileUploader.vue';

export default {
	name: 'DamageAssessorCaseDocumentCardTab',

	components: {
		DocumentFileUploader,
	},

	props: {
		documents: {
			type: Array,
			default: () => [],
		},

		isEditable: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		getDocumentName(document) {
			const media = document?.media;

			if (!media) {
				return '-';
			}

			return media.name ?? media.file_name ?? `${document.title}.${media.extension ?? 'pdf'}`;
		},
		upload(document, base64Content) {
			this.$emit('upload', {
				document,
				base64Content,
			});
		},
		formatDocumentDate(value) {
			if (!value) {
				return '';
			}
			const parts = value.split('-');

			if (parts.length !== 3) {
				return value;
			}

			return `${parts[2]}.${parts[1]}.${parts[0]}`;
		},
	},
};
</script>

<style scoped>
.document-row {
	@apply flex justify-between text-left py-2 text-sm;
}

.document-action {
	@apply text-white px-1 text-xs h-5 flex items-center justify-center;
	min-width: 20px;
}

.upload-action,
.view-action {
	@apply bg-connectProBlue cursor-pointer;
}

.disabled-action {
	@apply bg-gray-400 cursor-not-allowed;
}
</style>
